import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import CHECK_IN from './checkin';

const Kiosk = withLazyFallback(() => import('components/Kiosk/Kiosk'));
const KioskActivate = withLazyFallback(() => import('components/Kiosk/views/Activate'));
const KioskIdle = withLazyFallback(() => import('components/Kiosk/views/Idle'));
const KioskPayment = withLazyFallback(() => import('components/Kiosk/views/Payment'));
const KioskSaveCard = withLazyFallback(() => import('components/Kiosk/views/SaveCard'));
const KioskPhone = withLazyFallback(() => import('components/Kiosk/views/Phone'));
const RegisterPatient = withLazyFallback(() => import('components/Kiosk/views/RegisterPatient'));
const KioskValidation = withLazyFallback(() => import('components/Kiosk/views/Validation'));
const KioskScheduleAppointment = withLazyFallback(
  () => import('components/Kiosk/views/ScheduleAppointment')
);
const NotFound = withLazyFallback(() => import('components/NotFound'));

const KIOSK = [
  {
    path: 'kiosk',
    element: <Kiosk />,
    children: [
      { path: '', element: <KioskIdle /> },
      { path: 'idle', element: <KioskIdle /> },
      { path: 'phone', element: <KioskPhone /> },
      { path: 'activate', element: <KioskActivate /> },
      { path: 'register', element: <RegisterPatient /> },
      { path: 'validation', element: <KioskValidation /> },
      { path: 'payment/:token', element: <KioskPayment /> },
      { path: 'save-card', element: <KioskSaveCard /> },
      { path: 'schedule-appointment', element: <KioskScheduleAppointment /> },
      ...CHECK_IN,
      { path: '*', element: <NotFound portal="kiosk" /> }
    ]
  }
];

export default KIOSK;
